/* eslint-disable */


/**
 * Create styles for `<OrderList />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderList />` styles
 */
const orderListStyles = ({ theme }) => ({
  root: {
    backgroundColor: `#fff`,
    padding: `0 0 ${theme.spacing(1) * 2}px ${theme.spacing(1) * 2}px`,
  },
});

export default orderListStyles;
